module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Medium.0b78e96.woff";